module.exports = __webpack_public_path__ + "static/media/depths_background.80f711c4.png";